/** @jsx jsx */

import { formatDistanceToNowStrict } from 'date-fns';

import { Text, TooltipWrapper } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import { useQueryAnalytics } from 'app/developer-v3/hooks';

const Styles = {
  tooltip: css`
    min-width: 200px;
  `,
};

type Props = {
  integrationId: number;
  version: string;
};

function ZapCount({ integrationId, version }: Props) {
  const { isLoading, data } = useQueryAnalytics({
    integrationId,
    version,
  });

  const countLiveZaps = data?.app?.[0]?.zapsLive ?? 0;
  const timestamp = data?.timestamp;

  return isLoading ? null : (
    <TooltipWrapper
      allowMultilineTooltip={true}
      content={
        <div css={Styles.tooltip}>
          <Text color="inherit" fontWeight={600} margin="0 0 1rem" tag="p">
            Count of live Zaps that are currently turned on.
          </Text>
          {timestamp && (
            <Text color="inherit" fontWeight={600} tag="p">
              Updated{' '}
              {formatDistanceToNowStrict(timestamp * 1000, { addSuffix: true })}
              .
            </Text>
          )}
        </div>
      }
    >
      {() => <span aria-label="Zap count">{countLiveZaps}</span>}
    </TooltipWrapper>
  );
}

export default ZapCount;
